import App from "@/app/App.vue"
import router from "@/app/router"
import i18n from "@/shared/i18n/i18n"
import { initScrollToTopContent } from "@/shared/lib"
import { App as IonicApp, type URLOpenListenerEvent } from "@capacitor/app"
import { SplashScreen } from "@capacitor/splash-screen"
import { IonicVue } from "@ionic/vue"
import { createPinia } from "pinia"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
import { createApp } from "vue"

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css"

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css"
import "@ionic/vue/css/structure.css"
import "@ionic/vue/css/typography.css"

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/display.css"
import "@ionic/vue/css/flex-utils.css"
import "@ionic/vue/css/float-elements.css"
import "@ionic/vue/css/padding.css"
import "@ionic/vue/css/text-alignment.css"
import "@ionic/vue/css/text-transformation.css"

import "@/app/styles/index.scss"

import "@ionic/vue/css/palettes/dark.system.css"

import type { Router } from "vue-router"
import { useAppVersionCheck } from "./features/appversion"
import { LongPress } from "./shared/directive"

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
    .use(i18n)
    .use(pinia)
    .use(IonicVue)
    .use(router)
    .directive("longpress", LongPress)

router.isReady().then(async() => {
    app.mount("#app");

    // грузим только когда браузер «освободится», без блокировки first paint
    (window.requestIdleCallback ?? ((cb: any) => setTimeout(cb, 0)))(async() => {
        const { initHighlight } = await import("@/shared/lib/highlight/init")
        initHighlight()
    })

    initScrollToTopContent()
    await SplashScreen.hide()
    await checkAppLaunchUrl()
    checkAppVersion(router)
})

// Check incoming Deep Link request when App isn't loaded yet
async function checkAppLaunchUrl() {
    const result = await IonicApp.getLaunchUrl()
    if (result && typeof result === "object" && result.url) {
        console.log("appUrlOpen: ", result.url)
        const slug = result.url.split(".ru").pop()
        console.log("slug: ", slug)

        if (slug)
            router.push({ path: slug })
    }
}

function checkAppVersion(router: Router) {
    const { makeDecisionBasedOnAppVersionCheck } = useAppVersionCheck()

    makeDecisionBasedOnAppVersionCheck(router)
}

// Check incoming Deep Link request when App is already running
IonicApp.addListener("appUrlOpen", async function(event: URLOpenListenerEvent) {
    console.log("appUrlOpen: ", event)
    const slug = event.url.split(".ru").pop()
    console.log("slug: ", slug)

    if (slug)
        router.push({ path: slug })
})
